// @flow
import { Dropdown as AntdDropdown } from "antd";
import * as React from "react";

export type DropdownItem = {
  key: string,
  label: string | React.Node,
  icon?: React.ComponentType<any>,
  disabled?: boolean,
};

type Props = {
  className?: string,
  children?: React.Node,
  items: DropdownItem[],
  disabled?: boolean,
  showOnHover?: boolean,
  placement?:
    | "topLeft"
    | "topCenter"
    | "topRight"
    | "bottomLeft"
    | "bottomCenter"
    | "bottomRight"
    | "top"
    | "bottom"
    | void,
};

const Dropdown = ({
  children,
  items,
  showOnHover = false,
  placement = "bottomRight",
  ...props
}: Props): React.Node => {
  const menuItems = React.useMemo(() => {
    return items.map((item) => ({
      ...item,
      label:
        item.label instanceof String ? <span>{item.label}</span> : item.label,
    }));
  }, [items]);

  return (
    // $FlowIgnore
    <AntdDropdown
      menu={{ items: menuItems }}
      placement={placement}
      trigger={showOnHover ? [] : ["click"]}
      {...props}
    >
      {children}
    </AntdDropdown>
  );
};

export default Dropdown;
